import { useState } from "react";
import { ArrowRight, ScanFace, X } from "lucide-react";
import { zoneName } from "../lib/i18n";

export const SKIN_ISSUES = ["swelling", "redness", "pimple", "spot", "itch", "wound", "other"];

export const SkinToggle = ({ t, active, onToggle }) => (
  <div className="absolute left-4 top-[132px] z-10 sm:left-6">
    <button data-testid="skin-mode-btn" aria-pressed={active} onClick={onToggle} title={t("skinTitle")}
      className={`fade-up flex h-10 items-center gap-1.5 rounded-full px-3 text-xs font-semibold shadow-md transition-colors ${active ? "bg-orange-500 text-white" : "bg-white/90 text-slate-700 ring-1 ring-slate-200 hover:bg-white"}`}>
      <ScanFace size={17} />{t("skinMode")}
    </button>
  </div>
);

export const SkinPanel = ({ t, lang, spot, onStart, onClose, loading }) => {
  const [issue, setIssue] = useState(null);
  return (
    <div className="card fade-up absolute inset-x-3 bottom-[100px] z-20 rounded-2xl p-4 sm:inset-x-auto sm:bottom-6 sm:right-6 sm:w-[320px]" data-testid="skin-panel">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="truncate text-[11px] text-slate-500" data-testid="skin-zone-name">{zoneName(lang, spot.zone, spot.side)}</p>
          <p className="font-display text-sm font-bold text-slate-900">{t("skinWhat")}</p>
        </div>
        <button data-testid="skin-panel-close-btn" onClick={onClose} aria-label={t("close")}
          className="grid h-7 w-7 shrink-0 place-items-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700"><X size={14} /></button>
      </div>
      <div className="mt-2.5 flex flex-wrap gap-1.5">
        {SKIN_ISSUES.map((k) => (
          <button key={k} data-testid={`skin-issue-${k}`} onClick={() => setIssue(k)}
            className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${issue === k ? "bg-orange-500 text-white" : "bg-white text-slate-700 ring-1 ring-slate-200 hover:ring-orange-300"}`}>
            {t(`skin_${k}`)}
          </button>
        ))}
      </div>
      <button data-testid="skin-start-btn" disabled={!issue || loading} onClick={() => onStart(issue)} className="btn-primary mt-3 w-full !py-2 !text-sm">
        {t("startConsult")} <ArrowRight size={14} />
      </button>
    </div>
  );
};
